import { ReactElement } from 'react';

//import { HirePlanFormProvider } from '../../../contexts/HirePlanFormProviderGdf';
//import { HirePlanFormProvider } from '../../../contexts/HirePlanFormProvider';
import { useRouteLoaderData } from 'react-router-dom';

import { IncludeFunctionaryProvider } from '../../../contexts/IncludeFunctionaryFormProvider';
import { useHirePlanFormStepStore } from '../../../stores/useHirePlanFormStepStore';
import { useWindowSizeStore } from '../../../stores/useWindowSizeStore';
import { FunctionaryBreadcrumbSteps } from '../data/breadcrumb';
import { HirePlanFormStepHandler } from '../Functionary-steps/HirePlanFormStepHandler';
import { HirePlanFormBreadcrumb } from '../HirePlanFormBreadcrumb';
import { HirePlanMobileBreadcrumb } from '../mobile/HirePlanMobileBreadcrumb';

export function HirePlanForm(): ReactElement {
  const EmpresaData: any = useRouteLoaderData('Empresa-token');
  const data = EmpresaData;

  const step = useHirePlanFormStepStore(state => state.step);
  const width = useWindowSizeStore(state => state.width);

  return (
    <div className="bg-white min-[748px]:pt-4 min-[748px]:px-14 pb-14 flex flex-col min-[748px]:shadow-card min-[748px]:rounded-b-xl items-center">
      {width >= 748 ? (
        <HirePlanFormBreadcrumb.Root>
          {FunctionaryBreadcrumbSteps.map((item, index) => (
            <HirePlanFormBreadcrumb.Item
              key={item.name}
              text={item.name}
              number={index + 1}
              active={item.step === step}
            />
          ))}
        </HirePlanFormBreadcrumb.Root>
      ) : (
        <HirePlanMobileBreadcrumb />
      )}

      <IncludeFunctionaryProvider>
        <HirePlanFormStepHandler />
      </IncludeFunctionaryProvider>
    </div>
  );
}
